var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 161,
    viewBox: "0 0 120 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 159.134,
    rx: 5.5,
    fill: "#FAFAF9",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.599 97.1378V58.9373C61.599 58.6453 61.9737 58.5254 62.1432 58.7631L83.7715 89.0889C83.8866 89.2504 83.8162 89.4772 83.6298 89.545L62.0016 97.4197C61.806 97.4909 61.599 97.346 61.599 97.1378Z",
    fill: "#2E2E2D",
    stroke: "#2E2E2D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4114 100.911V62.7107C58.4114 62.4188 58.0367 62.2988 57.8671 62.5365L36.2389 92.8624C36.1238 93.0238 36.1942 93.2506 36.3805 93.3185L58.0087 101.193C58.2044 101.264 58.4114 101.119 58.4114 100.911Z",
    stroke: "#2E2E2D",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2215 86.5357L36.864 93.0092C36.5878 93.0929 36.5775 93.4802 36.8488 93.5784L58.2041 101.31C58.2705 101.334 58.3433 101.334 58.4097 101.309L79.948 93.3974C80.2196 93.2976 80.2065 92.909 79.9287 92.8278L58.3927 86.5348C58.3368 86.5185 58.2773 86.5188 58.2215 86.5357Z",
    stroke: "#2E2E2D",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookCover);
export default __webpack_public_path__ + "static/media/bookCover.a6ffe4af68587cf9168b96873b7ccc23.svg";
export { ForwardRef as ReactComponent };